<template>
    <div>
        
    </div>
</template>

<script>
    export default {
        created() {
            this.$store.state.loading = true;
            this.$store.dispatch('LOGOUT');
        }
    }
</script>